import { useCoverageRequests } from "@/entities/coverage-request";
import { usePermissions } from "@/entities/session/hooks/usePermissions";
import { PERMISSIONS } from "@/shared/config/permissions";

/**
 * Counts rendered against navigation items, keyed by nav item id. This is the one place
 * navigation is allowed to know about a feature: consumers read the map and stay generic,
 * so adding a badge means adding a line here rather than a branch in the sidebar.
 */
export function useNavBadges(options: { enabled?: boolean } = {}): Record<string, number | undefined> {
  const enabled = options.enabled ?? true;
  const { hasPermission } = usePermissions();

  const awaitingCoverage = useCoverageRequests(
    { status: "Submitted", isLapsed: false, pageSize: 1 },
    { enabled: enabled && hasPermission(PERMISSIONS.CoverageRequestsView) },
  );

  const awaitingCount = awaitingCoverage.data?.totalCount ?? 0;

  return {
    "coverage-requests": awaitingCount > 0 ? awaitingCount : undefined,
  };
}
